import axios from "axios";
import {API_BASE_URL1 } from "../Services/baseApiUrl";
import axiosInstance from "../../Hooks/axoisInstance";

const getToken = () => {
  return localStorage.getItem("token");
};
 
 
export const GetZone = async () => {
 
  try {
    const response = await axiosInstance.get(API_BASE_URL1+`MasterDetails/GetAllZone`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const AddZoneDetails = async (zoneData) => {
  try {
    const response = await axiosInstance.post(API_BASE_URL1 + `MasterCreate/AddNewZone`, zoneData,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`
        },
 
      });

    return response;
  } catch (error) {
    throw error
    //console.log(error)
  }
};
 
export const GetZoneById = async (zoneeId) => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `zone/zoneById/${zoneeId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error
  }
}
 
// export const GetCircle = async () => {
//   try {
//     const response = await axios.get(API_BASE_URL1 + `MasterDetails/GetAllCircles`,
//       {
//         headers: {
//           Authorization: `Bearer ${getToken()}`
//         }
//       }
//     );
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };
 
 
// export const GetCircle = async () => {
//   const cacheKey = "getCircle";
//   const cacheExpiryKey = "getCircleExpiry";
//   const cacheExpiryTime = 10 * 60 * 1000; // 10 minutes in milliseconds

//   // Retrieve the cached data and its expiry time
//   const cachedData = sessionStorage.getItem(cacheKey);
//   const cachedExpiryTime = sessionStorage.getItem(cacheExpiryKey);

//   // Check if the cached data exists and is still valid
//   if (cachedData && cachedExpiryTime) {
//     const now = new Date().getTime();

//     if (now < parseInt(cachedExpiryTime)) {
//       return JSON.parse(cachedData); // Return the cached data if valid
//     } else {
//       // Remove the cached data if expired
//       sessionStorage.removeItem(cacheKey);
//       sessionStorage.removeItem(cacheExpiryKey);
//     }
//   }

//   try {
//     // If there's no valid cached data, make the API call
//     const response = await axios.get(API_BASE_URL1 + `MasterDetails/GetAllCircles`, {
//       headers: {
//         Authorization: `Bearer ${getToken()}`
//       }
//     });

//     // Store the data in session storage along with the current timestamp
//     sessionStorage.setItem(cacheKey, JSON.stringify(response.data));
//     sessionStorage.setItem(cacheExpiryKey, new Date().getTime() + cacheExpiryTime);

//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };
export const GetCircle = async () => {
 
  try {
    const response = await axiosInstance.get(API_BASE_URL1+`MasterDetails/GetAllCircles`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const CreateCircleDeatails = async (zoneData) => {
  try {
    const response = await axiosInstance.post(API_BASE_URL1 + `MasterCreate/AddNewCircle`, zoneData,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`
        },
 
      });
 
    console.log(response.data, 'circle respone create')
 
 
    // if (!response.ok) {
    // throw new Error("Failed to add circle");
    // }
 
    return response;
  } catch (error) {
        throw error;
   
  }
};
 
 
 
export const GetWard = async () => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetAllWard`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// export const GetWard = async () => {
//   const cacheKey = "getWard";
//   const cacheExpiryKey = "getWardExpiry";
//   const cacheExpiryTime = 10 * 60 * 1000; // 10 minutes in milliseconds

//   // Retrieve the cached data and its expiry time
//   const cachedData = sessionStorage.getItem(cacheKey);
//   const cachedExpiryTime = sessionStorage.getItem(cacheExpiryKey);

//   // Check if the cached data exists and is still valid
//   if (cachedData && cachedExpiryTime) {
//     const now = new Date().getTime();

//     if (now < parseInt(cachedExpiryTime)) {
//       return JSON.parse(cachedData); // Return the cached data if valid
//     } else {
//       // Remove the cached data if expired
//       sessionStorage.removeItem(cacheKey);
//       sessionStorage.removeItem(cacheExpiryKey);
//     }
//   }

//   try {
//     // If there's no valid cached data, make the API call
//     const response = await axios.get(API_BASE_URL1 + `MasterDetails/GetAllWard`, {
//       headers: {
//         Authorization: `Bearer ${getToken()}`
//       }
//     });

//     // Store the data in session storage along with the current timestamp
//     sessionStorage.setItem(cacheKey, JSON.stringify(response.data));
//     sessionStorage.setItem(cacheExpiryKey, new Date().getTime() + cacheExpiryTime);

//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };


 
export const GetDatabyWardID = async (wardId) => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetDataByWardId?wardId=${wardId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
     throw error;
  }
};

export const GetCirclebyID = async (zoneId) => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetCircleByZoneId?ZoneId=${zoneId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
 
 
export const CreateWardDeatails = async (wardData) => {
  try {
    const response = await axiosInstance.post(API_BASE_URL1 + `MasterCreate/AddNewWard`, wardData,
      {
        headers: {
          // 'Content-Type': 'multipart/form-data',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`
        },
 
      });
 
    console.log(response.data, 'ward respone create')
    return response;
  }
  catch (error) {
        throw error;
   
  }
 
  // if (!response.ok) {
};
 
 
 
export const GetWardsbyCircleId = async (circleId) => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetWardByCircleId?CircleId=${circleId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
 
export const UpdateZoneDetails = async (zoneData) => {
  try {
    const response = await axiosInstance.put(API_BASE_URL1 + `MasterCreate/UpdateZoneDetails`, zoneData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        },
 
      });
 
    console.log(response.data, 'zone update')
    // toast.success('Zone updated Successfully!', {
    //     position: 'top-right',
    //     autoClose: 3000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    // })
 
    // if (!response.ok) {
    //   throw new Error("Failed to update zone");
    // }
 
    return response;
  } catch (error) {
    throw error
   
  }
};
 
export const UpdateCircleDetails = async (circleData) => {
  try {
    const response = await axiosInstance.put(API_BASE_URL1 + `MasterCreate/UpdateCircleDetails`, circleData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        },
 
      });
 
    console.log(response.data, 'circle update')
    // toast.success('Circle updated Successfully!', {
    //     position: 'top-right',
    //     autoClose: 3000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    // })
 
    // if (!response.ok) {
    //   throw new Error("Failed to update circle");
    // }
 
    return response;
  } catch (error) {
        throw error
   
  }
};
 
export const UpdateWardDetails = async (WardData) => {
  try {
    const response = await axiosInstance.put(API_BASE_URL1 + `MasterCreate/UpdateWardDetails`, WardData,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`
        },
 
      });
 
    //  const successMessage = 'Ward Updated Successfully!'
    // toast.success(successMessage, {
    //     position: 'top-right',
    //     autoClose: 3000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    // })
 
    // if (!response.ok) {
    //     throw new Error("Failed to Update Ward");
    // }
 
    return response;
  } catch (error) {
    // throw new Error("Error adding TransferStation: " + error);
    throw error
   
 
  }
};
 
export const GetCity = async () => {
 
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `city/getAllCities`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
 
export const getWardById = async (id) => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `ward/getById/${id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        },
 
      });
    // console.log(response, 'response')
    return response;
  } catch (error) {
    throw error
   
  }
};
 
export const getCircleById = async (id) => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `circle/getById/${id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        },
 
      });
    // console.log(response, 'response')
    return response;
  } catch (error) {
    throw error
   
  }
};
 
export const getZoneById = async (id) => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `zone/zoneById/${id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        },
 
      });
    // console.log(response, 'responsebyid')
    return response;
  } catch (error) {
    throw error
   
  }
};



